import * as events from '../Bus/Bus';
import * as mainDOMRefs from '../Main/MainDOMRefs';
import { Annotations } from '../../Annotations/Annotations';
import { Utilities } from '../Utility/Utilities';

export class MainResetEvents {
    public constructor(
        protected eventMultipleFeaturesSelectedUnsubscribe, protected eventRectangleSelectionCompleteUnsubscribe,
        protected annotations: Annotations
    ) {

    }

    public resetButtons = ( enableInfoSelect: boolean = false ): void => {
        // SHARED
        Utilities.GetControl(mainDOMRefs.jqc.layersBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.searchBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.mapTreeSelectBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.mapInfoSelectBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.mapFeatureSelectBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.additionalMapToolsBtn).removeClass('mapActionSelected');

        // REPORT AN ISSUE
        Utilities.GetControl(mainDOMRefs.jqc.reportAnIssue_MyIssuesBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.reportAnIssue_CreateBtn).removeClass('mapActionSelected');

        // OFFICER MAP
        Utilities.GetControl(mainDOMRefs.jqc.recordListBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.newMaintBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.newInfraBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.newLandBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.newRouteBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.newPathBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.newTaskBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.newFeatureBtn).removeClass('mapActionSelected');

        // MY TASKS
        Utilities.GetControl(mainDOMRefs.jqc.myTasksRecordListBtn).removeClass('mapActionSelected');

        // TASK MANAGEMENT
        Utilities.GetControl(mainDOMRefs.jqc.taskManagementRecordListBtn).removeClass('mapActionSelected');

        // SUBMISSIONS
        Utilities.GetControl(mainDOMRefs.jqc.submissionListPanelBtn).removeClass('mapActionSelected');

        // LEGAL
        Utilities.GetControl(mainDOMRefs.jqc.legalEventsBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.newLegalEventsBtn).removeClass('mapActionSelected');

        // CONSULTATIONS
        Utilities.GetControl(mainDOMRefs.jqc.consultationsBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.consultationsRegisterBtn).removeClass('mapActionSelected');

        // ANNOTATIONS
        Utilities.GetControl(mainDOMRefs.jqc.annotationsListBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.annotationsNewBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.annotationsReportBtn).removeClass('mapActionSelected');

        // TRO
        Utilities.GetControl(mainDOMRefs.jqc.troListBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.troNewBtn).removeClass('mapActionSelected');

        if (this.eventMultipleFeaturesSelectedUnsubscribe) this.eventMultipleFeaturesSelectedUnsubscribe();
        if (this.eventRectangleSelectionCompleteUnsubscribe) this.eventRectangleSelectionCompleteUnsubscribe();

        //if (enableInfoSelect == true) {
        //    Utilities.GetControl(mainDOMRefs.jqc.mapInfoSelectBtn).click();
        //}

        // Reset Map Draw events
        events.bus.publish(events.eventNewMapGeometryCompleted([false, null]));

        $('.ol-layer').css("cursor", "default");
    }

    public resetLeftPanels = (): void => {
        // SHARED
        Utilities.GetControl(mainDOMRefs.jqc.selectListPanel).removeClass('show');
        Utilities.GetControl(mainDOMRefs.jqc.featureDetailsPanel).removeClass('show');
        Utilities.GetControl(mainDOMRefs.jqc.featureDetailsPanel).removeClass('show400');
        Utilities.GetControl(mainDOMRefs.jqc.featureDetailsPanel).removeClass('show500');
        Utilities.GetControl(mainDOMRefs.jqc.featureDetailsPanel).removeClass('show600');
        Utilities.GetControl(mainDOMRefs.jqc.mapButtonsPanel).removeClass('show');
        Utilities.GetControl(mainDOMRefs.jqc.mapMessageContainer).removeClass('show');
        Utilities.GetControl(mainDOMRefs.jqc.infoDetailsPanel).removeClass('show');

        // REPORT AN ISSUE
        Utilities.GetControl(mainDOMRefs.jqc.reportAnIssueMyIssuesPanel).removeClass('show');
        Utilities.GetControl(mainDOMRefs.jqc.reportAnIssueNewMaintPanel).removeClass('show');

        // OFFICER MAP
        $('#recordListPanel').removeClass('show');
        $('#newFeaturePanel').removeClass('show');
        this.eventResetLeftWizardPanels();
        this.annotations.removeMapInteractions();

        // MY TASKS
        $('#myTasksRecordListPanel').removeClass('show');

        // TASK MANAGEMENT
        $('#taskManagementRecordListPanel').removeClass('show');
        $('#taskManagementRecordListTaskEditContainer').removeClass('show');
        $('#taskManagementRecordListTaskEditContainer').removeClass('show600');

        // SUBMISSIONS
        $('#submissionListPanel').removeClass('show');
        $('#submissionListEditContainer').removeClass('show');
        $('#submissionListEditContainer').removeClass('show600');

        // LEGAL
        $('#legalPanel').removeClass('show');
        $('#addPathLegalWizardPanel').removeClass('show');
        
        // CONSULTATIONS
        $('#consultationsGroupListPanel').removeClass('show');
        $('#consultationsPanel').removeClass('show');

        // ANNOTATIONS
        $('#annotationsPanel').removeClass('show');
        $('#newAnnotationsPanel').removeClass('show');

        // TRO
        $('#TROPanel').removeClass('show');
        $('#newTROWizardPanel').removeClass('show');
        $('#addAffectedPathTROWizardPanel').removeClass('show');

        // CONDITION SURVEY
        $('#conditionSurveyListPanel').removeClass('show');

        // Reset Map Draw events
        events.bus.publish(events.eventNewMapGeometryCompleted([false, null]));
    }

    public eventResetLeftWizardPanels = (): void => {
        // OFFICER MAP
        $('#newFeaturePanel').removeClass('show');
        $('#newMaintPanel').removeClass('show');
        $('#newInfraPanel').removeClass('show');
        $('#newRoutePanel').removeClass('show');
        $('#newLandPanel').removeClass('show');
        $('#reparentWizardPanel').removeClass('show');
        $('#newAnnotationPanel').removeClass('show');
        $('#newTaskPanel').removeClass('show');
        $('#submissionsMergePanel').removeClass('show');
    }

    public resetRightPanels = (): void => {
        Utilities.GetControl(mainDOMRefs.jqc.layerPanel).removeClass('show');
        Utilities.GetControl(mainDOMRefs.jqc.searchPanel).removeClass('show');
        Utilities.GetControl(mainDOMRefs.jqc.additionalMapToolsPanel).removeClass('show');
        Utilities.GetControl(mainDOMRefs.jqc.notificationPanelContainer).removeClass("show");
        $('#treeSelectPanel').removeClass('show');
        $('#treeResultsPanel').removeClass('show');

        Utilities.GetControl(mainDOMRefs.jqc.mapInfoSelectBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.searchBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.additionalMapToolsBtn).removeClass('mapActionSelected');
        Utilities.GetControl(mainDOMRefs.jqc.layersBtn).removeClass('mapActionSelected');
    }
}




